import { TailSpin } from "react-loader-spinner";

const FullScreenLoading = ({ visible }) => {
    if (!visible) return null;

    return (
        <div
            style={{
                position: "fixed", // Ensures the div is positioned relative to the viewport
                top: 0, // Aligns the div to the top of the viewport
                left: 0, // Aligns the div to the left of the viewport
                width: "100%",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(0, 0, 0, 0.5)", // Optional: adds a semi-transparent background
                zIndex: 9999, // Ensures the div is rendered above other content
            }}
        >
            <TailSpin
                height="80"
                width="80"
                color="#000"
                ariaLabel="tail-spin-loading"
                radius="1"
                wrapperStyle={{}}
                wrapperClass=""
                visible={visible}
            />
        </div>
    );
};

export default FullScreenLoading;
